import React from 'react';
import { Image, imageProps } from '@is24at/react-image';
import { type ImageSizeSet } from '@is24at/react-image/src/types/global.d';
import { ImagePlaceholder } from 'assets/ImagePlaceholder';
import styles from './RealtorLogo.scss';

const LogoSizeSet = {
  GLOBAL: { width: 100, height: 40 },
} as ImageSizeSet;

const RealtorLogo = ({ logoUrl }: any) => (
  <div className={styles['realtor-logo']}>
    {logoUrl ? (
      <Image
        pictureCn={styles['realtor-logo__picture']}
        imageCn={styles['realtor-logo__image']}
        alt="Maklerlogo"
        {...imageProps(logoUrl, LogoSizeSet)}
      />
    ) : (
      <ImagePlaceholder />
    )}
  </div>
);

export default RealtorLogo;
